import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import svResources from '../locales/sv/translation.json';
import enResources from '../locales/en/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['querystring', 'htmlTag', 'navigator'],
      caches: [],
    },
    load: 'languageOnly',
    supportedLngs: ['sv', 'en', 'dev'],
    fallbackLng: 'sv',
    lng: 'sv',
    resources: {
      sv: { translation: svResources },
      en: { translation: enResources },
    },
    interpolation: {
      escapeValue: false, // not needed for React as it escapes by default
    },
  });

export default i18n;
